import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CategoriesService, FormatType } from '@src/api/reports';
import { FormComponent, RowComponent, FieldComponent } from '@src/app/components';

import { FormType } from './types';
import { StatusComponent, TemplatesComponent } from './components';
import { ReportTemplateUI } from './components/templates';

@Component({
  selector: 'common-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormComponent,
    RowComponent,
    FieldComponent,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    InputSwitchModule,
    StatusComponent,
    TemplatesComponent,
    InputTextareaModule,
  ],
  templateUrl: './common-form.component.html',
  styleUrl: './common-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonFormComponent {
  @Input() loading = false;
  @Input() form!: FormGroup<FormType>;

  readonly formats = Object.values(FormatType);

  private readonly categoriesService = inject(CategoriesService);
  categories$ = this.categoriesService.findFirst1000Category();

  templatesVisible = false;

  readonly maxSelectedCategories = 5;
  readonly maxSelectedFormats = 6;

  get templateControl() {
    return this.form.controls.template;
  }

  get templateName() {
    return this.templateControl.value?.name;
  }

  get categoriesControlValue() {
    return this.form.controls.categories.value;
  }

  get formatsControlValue() {
    return this.form.controls.formats.value;
  }

  selectedTemplateChange(template?: ReportTemplateUI) {
    this.templateControl.setValue(template);
    this.templatesVisible = false;
  }
}
